module.exports = __webpack_public_path__ + "img/Julka.2f43a973.jpeg";